import React from 'react';

import SiteNav from '../SiteNav';

import styles from './PackageRequest.module.scss';

import purpleLoveHeart from '../../public/images/purple-love-heart-icon.svg';

const {
  'package-request': packageRequestClass,
  'package-request-body': packageRequestBodyClass
} = styles;

const PackageRequest = () => {
  return (
    <div className={packageRequestClass}>
      <SiteNav />
      <div className={packageRequestBodyClass}>
        <img src={purpleLoveHeart} alt="heart-icon" />
        <h1>Thank you!</h1>
        <p>
          A member of our team will follow up with you soon on the status of your package request.
        </p>
      </div>
    </div>
  );
};

export default PackageRequest;
